import { useState, useEffect } from 'react';
import styles from './weather.module.css';
import { Link } from 'react-router-dom';

import { dayOnly } from '../utils/dateConverter';
import { useTripInfo } from "../context";
import { getWeatherIcon } from '../utils/weatherIcons';



export function Weather(props) {


    const { weatherActive, currentTripId } = useTripInfo();

    const [width, setWidth] = useState(window.innerWidth);
    const [fahrenheit, setFahrenheit] = useState(true);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);





    const howMuch = () => {
        if (width < 510) {
            return [0, 4]
        } else if (width < 630) {
            return [0, 5]
        }
        else if (width < 720) {
            return [0, 6]
        } else if (width < 800) {
            return [0, 7]
        } else if (width < 900) {
            return [0, 8]
        } else if (width < 1000) {
            return [0, 9]
        } else {
            return [0, 10]
        }

    }

    function celsiusToFahrenheit(celsius) {
        return Math.round((celsius * 9 / 5) + 32);

    }

    return (





        <div className={styles.mainWBox}>



{console.warn(weatherActive)}
            {weatherActive.active ?

                props.destinationForWeather ?
                    <>

                        <div className={styles.weatherForecast}>



                            <div className={styles.weatherheader}>
                                <h2 className="text-2xl font-bold text-gray-800">Weather Forecast</h2>
                                <div className={styles.buttons}>
                                    <div className={styles.segmentedControl}>
                                        <div className={styles.slider} style={{ left: fahrenheit ? '50%' : '0%' }} />
                                        <div className={`${styles.segmentedControlOption} ${!fahrenheit ? styles.active : ''}`} onClick={() => setFahrenheit(false)}>C</div>
                                        <div className={`${styles.segmentedControlOption} ${fahrenheit ? styles.active : ''}`} onClick={() => setFahrenheit(true)}>F</div>
                                    </div>


                                    <Link to='/weather'
                                        className={styles.more}>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg>
                                    </Link>
                                </div>
                            </div>
                            <div className={styles.weatherForecastContant}>

                            
                                {props.currentWeather.slice(...howMuch()).map((day, i) => {

                                    const type = day.daytimeForecast.weatherCondition.type;
                                    const icon = getWeatherIcon(type, 'day');

                                    return (

                                        <div key={i} className={styles.forEach}>
                                            <div>
                                                <p className="font-semibold text-gray-700 text-lg">{new Date(day.interval.startTime).toLocaleDateString("en-US", dayOnly)}</p>



                                            </div>

                                            <img src={icon} alt={type + 'icon'} />



                                            <div className={styles.minMax}>
                                                <p className="text-sm text-gray-500">
                                                    {fahrenheit ? celsiusToFahrenheit(day.maxTemperature.degrees) + '°F' : Math.round(day.maxTemperature.degrees) + '°C'}
                                                </p>

                                                <p className="text-sm text-gray-500">
                                                    {fahrenheit ? celsiusToFahrenheit(day.minTemperature.degrees) + '°F' : Math.round(day.minTemperature.degrees) + '°C'}
                                                </p>



                                            </div>
                                            {/* <p className="text-sm text-gray-500"></p>  */}
                                        </div>


                                    )
                                })}


                            </div>

                        </div>
                    </>
                    :
                    <div className={styles.weatherForecast2}>
                        <p style={{ fontWeight: '600' }}>Your current destination isn&apos;t valid for retrieving weather data!</p>
                        <p>
                            Please <Link className="text-gray-600 underline hover:text-blue-600" to={`/update_trip/${currentTripId}`}>update</Link> your destination with a more specific city or region to view the forecast.
                        </p>
                    </div>

                :



                <div className={styles.weatherForecast2}>

                    <p>Forecast will be available 5 days before your trip starts.! 🌤</p>
                </div>


            }










        </div>

    )
}